<template>
    <div class="box">
        <div class="headline mb42" ref="getheight1">绑定明细</div>
        <div class="v_header" ref="getheight">
            <div class="flexCenter">
                <el-input class="mr12" clearable v-model="page.search_name" @change="changeSearch_name" placeholder="搜索溯源码">
                </el-input>
                <!-- prefix-icon="el-icon-search" -->
                <el-button class="input_button" size="mini" @click="getExport()">导出</el-button>
            </div>
        </div>

        <el-table :data="message" :max-height="height + 'px'" style="width: 100%">
            <el-table-column fixed="" label="绑定时间" width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    {{ scope.row.created_on | formatOrdertime }}
                </template>
            </el-table-column>
            <el-table-column label="溯源码" min-width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.label" placement="bottom">
                        <span class="v_tips">{{ scope.row.label }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="奖励码" min-width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.red_envelope_label" placement="bottom">
                        <span class="v_tips">{{ scope.row.red_envelope_label }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="product_info.product_number" label="产品编号" width="150" :render-header="renderPrice">
            </el-table-column>
            <el-table-column prop="product_info.product_name" label="产品名称" width="180" :render-header="renderPrice"> </el-table-column>
        </el-table>
        <div class="notificationn" v-if="notificationns">
            <div class="notificationn_left"></div>
            <div>
                <div class="notificationn_title">{{ msg }}</div>
            </div>
        </div>
        <pagination :page="page" @getPage="getPage" @getNum="getNum"></pagination>
    </div>
</template>

<script>
import * as XLSX from 'xlsx';
export default {
    name: 'binding',
    data() {
        return {
            msg: '',
            notificationns: false,
            page: {
                num: 10,
                page: 1,
                total: 0,
                search_name: ''
            },
            message: [],
            height: '',
            pages:1,
            list:[]
        };
    },

    mounted() {
      
        window.screenHeight = document.body.clientHeight;
        this.screenHeight = window.screenHeight;
        this.height = this.screenHeight - this.$refs.getheight.offsetHeight - this.$refs.getheight1.offsetHeight - 85 - 24 - 17 - 40;
        this.getMessage(); //获取列表
    },
    methods: {
        renderPrice(h, { column, $index }) {
            const styleFilter = {
                fontSize: '16px',
                fontWeight: 'bold',
                marginLeft: '8px'
            };
            return [
                column.label,
                h(
                    'i',
                    [
                        h('span', {
                            class: { 'el-icon-bottom': true },
                            style: {
                                ...styleFilter //设置样式
                            }
                        })
                    ] // 图标
                )
            ];
        },
        getMessage() {
            let that = this;
            let obj = {
                page: that.page.page,
                num: that.page.num
                // page: 12,
                // num: 1000
            };
            if (that.page.search_name) {
                obj.search_name = that.page.search_name;
            }
            that.$get('/backapi/label_package', obj).then(function (res) {
                if (res.count) { 
                    // let label_info=[]
                    // console.log('res.data :>> ', res.data);
                    // for(let a=0;a<res.data.length;a++){

                    //     label_info.push({'label':res.data[a].label,'red_envelope_label':res.data[a].red_envelope_label})
                    // }
                    
                    // console.log(label_info);
                    that.page.total = res.count;
                    that.message = res.data;
                } else {
                    that.page.total = 0;
                    that.message = [];
                }
            });
        },
        getPage(e) {
            this.page.page = e;
            this.getMessage();
        },
        getNum(e) {
            this.page.num = e;
            this.page.page = 1;
            this.getMessage();
        },
        // 搜索溯源码
        changeSearch_name(e) {
                this.page.search_name = e;
                this.page.num = 10;
                this.page.page = 1;

            this.getMessage(); //获取列表
        },
        // 导出
        getExport() {
            let that = this;
            
            if (that.page.total == 0) {
                // that.$message({
                //     message: '暂无数据导出',
                //     type: 'warning'
                // });
                (that.msg = '暂无数据导出'), (that.notificationns = true);
                setTimeout(() => {
                    that.notificationns = false;
                }, 3000);
                return;
            }
            let obj = {
                page:that.pages,
                // num: 1000,
                is_download:true,
                num: that.page.total
            };
          
            that.$get('/backapi/label_package', obj).then(function (res) {
                if (res.code == 200) {
                        that.msg = '数据导出成功'
                         that.notificationns = true
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                    } else {
                        (that.msg = '导出失败'), (that.notificationns = true);
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                    }
                })
                .catch((reject) => {
                    (that.msg = '导出失败'), (that.notificationns = true);
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                });
                // if (res.code==200) {
                //     if (res.data.length != 0 && res.data) {
                //         const fdArray = [];
                //         that.list= that.list.concat(res.data)
                //         that.pages+=1
                //         if( that.list.length==46000||res.data.length<1000){
                //             that.list.forEach(function (item, index) {
                //             var obj = {
                //                 绑定时间: that.$formatOrdertime(item.created_on),
                //                 溯源码: item.label,
                //                 奖励码: item.red_envelope_label,
                //                 产品编号: item.product_info.product_name,
                //                 产品名称: item.product_info.product_name 
                //             };
                //             fdArray.push(obj);
                //         });
                //         var wb = XLSX.utils.book_new();
                //         let sheet = XLSX.utils.json_to_sheet(fdArray);
                //         sheet['!cols'] = [{ wch: 20 }, { wch: 30 }, { wch: 30 }, { wch: 20 }, { wch: 20 }];
                //         XLSX.utils.book_append_sheet(wb, sheet, 'sheet', { raw: true });
                //         XLSX.writeFile(wb, '绑定明细 - 数据列表' + '.xlsx');
                //         (that.msg = '数据导出成功'), (that.notificationns = true);
                //         setTimeout(() => {
                //             that.notificationns = false;
                //                that.list=[] 
                //         }, 3000);
                //          return 
                //         }
                        
                //         that.getExport()
                //     } else {
                //         (that.msg = '暂无数据导出'), (that.notificationns = true);
                //         setTimeout(() => {
                //             that.notificationns = false;
                //         }, 3000);
                //     }
                // } else {
                //     (that.msg = '暂无数据导出'), (that.notificationns = true);
                //     setTimeout(() => {
                //         that.notificationns = false;
                //     }, 3000);
                // }
            // });
        }
    }
};
</script>

<style scoped>
.v_header {
    display: flex;
    justify-content: end;
    margin-bottom: 17px;
}
.mb42 {
    margin-bottom: 24px;
}
/deep/.el-table thead {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #121619;
}
/deep/.el-table {
    font-weight: 400;
    font-size: 12px;
    color: #121619;
}
/deep/.el-table .el-table__cell {
    border: none;
}
/deep/.flexCenter .el-input .el-input__inner {
    background: #ffffff;
    border: 1px solid #16307c;
    border-radius: 4px;
    font-weight: 400;
    font-size: 16px;
    color: #121619;
    width: 100%;
    height: 35px;
    background: url('../../assets/img/search-outline.png') no-repeat 8px center;
    background-size: 24px;
    padding-left: 40px;
}
.mr12 {
    margin-right: 12px;
}
/deep/.flexCenter .el-input {
    width: 387px;
}
/deep/ el-input::-webkit-input-placeholder {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;

    letter-spacing: 0.5px;
    color: #ababab;
}
</style>
